/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsGenericNotificationTemplateData } from '../../models/mail-params-generic-notification-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendGenericNotificationMail$Params {
      body: MailParamsGenericNotificationTemplateData
}

export function sendGenericNotificationMail(http: HttpClient, rootUrl: string, params: SendGenericNotificationMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendGenericNotificationMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendGenericNotificationMail.PATH = '/sendMail/generic-notification';
